const DEFAULT_LOCALE = 'en-US';

function parseDayVal(val) {
  if (val > 10 && val < 20) {
    return `${val}th`;
  }

  const lastNum = val.toFixed(0).slice(-1);

  switch (lastNum) {
    case '1':
      return `${val}st`;
    case '2':
      return `${val}nd`;
    case '3':
      return `${val}rd`;
    default:
      return `${val}th`;
  }
}

function createDays() {
  return Array
    .from({ length: 31 }, (v, idx) => idx + 1)
    .reduce((acc, val) => Object.assign(acc, { [val]: parseDayVal(val) }), {});
}

const ordinalDays = createDays();

export default class KnotchDate {
  constructor(date) {
    this.date = date ? new Date(date) : new Date();
  }

  parse(options = { locale: DEFAULT_LOCALE, month: 'long' }) {
    return {
      day: ordinalDays[this.date.getUTCDate()],
      month: this.date.toLocaleString(options.locale, { month: options.month }),
      year: this.date.getFullYear(),
    };
  }
}
